import React from "react";

const Input = ({ name,
  label,
  value,
  onChange,
  error,
  type = "text",
  disable =false,
  search,
  onClick,
  placeholder = "",
  onKeyPress,
  onKeyDown,
  checked, }) => {
  return (
    <div className="input-group flex-nowrap">
    <input
      value={value}
      onChange={onChange}
      id={name}
      name={name}
      type={type}
      disabled ={disable}
      checked={checked}
      placeholder={placeholder}
      onKeyPress={onKeyPress}
      onKeyDown={onKeyDown}
      aria-describedby="addon-wrapping"
      className="form-control"  
    />
    {error && <div className="alert alert-danger">{error}</div>}
  </div>

  );
};

export default Input;
